export enum UserPlanStatus {
  USERPLAN_UNSET_STATUS = 'USERPLAN_UNSET_STATUS', // Do not use, needed because of proto3 limitations
  USERPLAN_INITIATED = 'USERPLAN_INITIATED',
  USERPLAN_PENDING = 'USERPLAN_PENDING',
  USERPLAN_PROCESSING_OLD = 'USERPLAN_PROCESSING_OLD',
  USERPLAN_CLOSED_OLD = 'USERPLAN_CLOSED_OLD',
  USERPLAN_ACTIVE = 'USERPLAN_ACTIVE',
  USERPLAN_CANCELED = 'USERPLAN_CANCELED',
  USERPLAN_ORDER_EXPIRED = 'USERPLAN_ORDER_EXPIRED',
  USERPLAN_STALLED = 'USERPLAN_STALLED',
  USERPLAN_REPLENISHING = 'USERPLAN_REPLENISHING',
  USERPLAN_TERMINATED = 'USERPLAN_TERMINATED',
  USERPLAN_EXPIRED = 'USERPLAN_EXPIRED',
  USERPLAN_PRE_TERMINATED = 'USERPLAN_PRE_TERMINATED',
}
